import React from 'react'
import LoadingScreen from './LoadingScreenComponent'
import Tabs from './TabsComponent'
import Tab from './TabComponent'
import TabCount from './TabCountComponent'
import TabText from './TabTextComponent'

import Api from '../services/ApiService'

export default class LocationComponent extends React.Component {

    constructor(props) {
        super(props)

        this.state = {
            locations: [],
            loadingScreen: {
                isLoading: false,
                text: 'Henter lokationer...'
            }
        }
    }

    componentDidMount() {
        Api.getLocations()
        .then(data => {
            this.setState({
                loadingScreen: {
                    isLoading: false
                },
                locations: data
            })
        })
        .catch(error => {
            this.setState({
                loadingScreen: {
                    text: 'Kan ikke få forbindelse til serveren.',
                    isLoading: true
                }
            })
        })
    }

    render () {
        let { locations } = this.state
        let { loadingScreen } = this.state
        
        if (loadingScreen.isLoading) {
            return <LoadingScreen text={loadingScreen.text} height="300" />
        } else {
            if (locations.length === 0) {
                return <p>Ingen lokationer</p>
            }

            if (locations.length === 1) {
                this.props.onSelectLocation(locations[0])
                return <p>Venter ...</p>
            }
            
            return (
                <Tabs>
                    {locations.map(location => {
                        const active =
                            this.props.location.location_id === location.location_id
                        return (
                            <Tab
                                key={location.location_id}
                                isTabAvailable={true}
                                active={active}
                                onClick={() => this.props.onSelectLocation(location)}
                            >
                                <TabCount active={active}>{location.name}</TabCount>
                                <TabText active={active}>{location.address + ', ' + location.zipcode + ' ' + location.city}</TabText>
                            </Tab>
                        )
                    })}
                </Tabs>
            )
        }
    }

}


// WEBPACK FOOTER //
// ./src/components/LocationComponent.jsx